import apiClient from "./apiClient";


const logos = [
    { id: 1, logoName: "client-1.png", name: "Maa Laxmi Engineering" },
    { id: 2, logoName: "client-2.png", name: "SibraZen" },
    { id: 3, logoName: "client-3.png", name: "Chakayatra" },
    { id: 4, logoName: "client-4.png", name: "Shreezaar" },
    { id: 5, logoName: "client-5.png", name: "Smart Inventory" },
    { id: 6, logoName: "client-6.png", name: "Retail Store" },
  ];


export const getClientLogos = async () => {
  try {
    const response = await apiClient.get("/client-logos");
    return response.data;
  } catch (error) {
      console.error("Error fetching client logos:", error);
      //throw error; // rethrow so component can handle it
      return logos;
  }
};
